import { render, staticRenderFns } from "./SchedulePeriodForDay.vue?vue&type=template&id=5a391861&"
import script from "./SchedulePeriodForDay.vue?vue&type=script&lang=js&"
export * from "./SchedulePeriodForDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports